module.exports = __webpack_public_path__ + "img/Shaws-Logo.3c643ca9.svg";